var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import classNames from 'classnames';
export var SpinButton = React.forwardRef(function (_a, ref) {
    var className = _a.className, onSpinButtonChange = _a.onSpinButtonChange, maxLength = _a.maxLength, min = _a.min, max = _a.max, value = _a.value, nextSpinButton = _a.nextSpinButton, prevSpinButton = _a.prevSpinButton, children = _a.children, rest = __rest(_a, ["className", "onSpinButtonChange", "maxLength", "min", "max", "value", "nextSpinButton", "prevSpinButton", "children"]);
    var history = useRef([]);
    var handleKeyDown = function (evt) {
        var _a, _b, _c;
        evt.stopPropagation();
        if (/\d/.test(evt.key)) {
            history.current =
                history.current.length === maxLength
                    ? (history.current = [parseInt(evt.key)])
                    : history.current.concat(parseInt(evt.key));
            onSpinButtonChange(history.current);
        }
        else if (evt.key === 'Backspace' || evt.key === 'Delete') {
            history.current = [];
            if (value === 0) {
                (_a = prevSpinButton === null || prevSpinButton === void 0 ? void 0 : prevSpinButton.current) === null || _a === void 0 ? void 0 : _a.focus();
                return;
            }
            var newValue = value === null || value === void 0 ? void 0 : value.toString().slice(0, -1);
            history.current = newValue
                ? newValue.split('').map(Number)
                : [];
            onSpinButtonChange(history.current);
        }
        else if (evt.key === 'ArrowUp') {
            evt.preventDefault();
            var newValue = (value !== null && value !== void 0 ? value : 0) + 1;
            if (newValue && newValue !== null && newValue > max) {
                newValue = min;
            }
            onSpinButtonChange([newValue], false);
        }
        else if (evt.key === 'ArrowDown') {
            evt.preventDefault();
            var newValue = (value !== null && value !== void 0 ? value : 0) - 1;
            if (newValue < min) {
                newValue = max;
            }
            onSpinButtonChange([newValue], false);
        }
        else if (evt.key === 'ArrowLeft') {
            evt.preventDefault();
            (_b = prevSpinButton === null || prevSpinButton === void 0 ? void 0 : prevSpinButton.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        else if (evt.key === 'ArrowRight') {
            evt.preventDefault();
            (_c = nextSpinButton === null || nextSpinButton === void 0 ? void 0 : nextSpinButton.current) === null || _c === void 0 ? void 0 : _c.focus();
        }
    };
    return (React.createElement("span", __assign({ role: 'spinbutton', inputMode: 'numeric', className: classNames(className, 'ffe-dateinput__field'), tabIndex: 0, onFocus: function () {
            history.current = [];
        }, "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": value, ref: ref, onKeyDown: handleKeyDown }, rest), children));
});
